export default "__VITE_ASSET__B1Gct4Nq__"